import { createContext, useContext } from 'react';
import type { GameObject } from '@magicyard/magicsnakes-game/src/Game';

const GameContext = createContext<GameObject>(null as any); // TODO this prolly should not be inited here

export const useGameObject = () => useContext(GameContext);

export default GameContext;
